type GalleryTileSkeletonProps = {
  testId: string;
};

// One flat block with a light sweep left to right across it, as in the design, sized like MediaFilePreview (the 4:5 image plus the
// footer, which sizes to the tile rather than the viewport) so tiles replace it without the grid jumping.
const GalleryTileSkeleton = ({ testId }: GalleryTileSkeletonProps) => (
  <div data-testid={testId} aria-hidden="true" className="relative flex flex-col overflow-hidden rounded-2xl bg-gray-3 [container-type:inline-size]">
    <div className="aspect-[4/5] w-full" />
    <div className="h-11 tile-lg:h-[60px]" />
    <div className="absolute inset-0 animate-shimmer bg-gradient-to-r from-transparent via-gray-12/5 to-transparent" />
  </div>
);

export default GalleryTileSkeleton;
